import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsSR: CultureInfo = {
  name: 'es-SR',
  displayName: 'español (Surinam)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-SR',
  parent: CultureInfoEs
};
